<shared-form-for-schedule [disabled]="isDisabled" [locationNo]="locationNo" *ngIf="periodsFiltered$ | async"
    (onInit)="handleFormInit($event)" [compact]="true" class="modal-for-schedule__form" [periods]="periodsFiltered$ | async"
    (onPickupSelected)="handlePickupTimeSelected($event)">
</shared-form-for-schedule>
